<template>
  <v-card class="image-block center-card rounded-lg" min-height="390px">
    <BannerIconShootingType :type="shooting.shootingType" :count="shooting.numberOfPictures" />
    <div v-if="shooting.shootingType !== 'VIDEO'" class="img-thumbnail-block rounded-lg rounded-b-0">
      <router-link :to="goToShooting">
        <v-img class="img-thumbnail rounded-0" :src="shooting.image"></v-img>
      </router-link>
    </div>
    <div v-else class="img-thumbnail-block">
      <router-link :to="goToShooting" style="text-decoration: none">
        <div class="video-thumbnail rounded-0">
          <v-icon size="x-large">play_arrow</v-icon>
        </div>
      </router-link>
    </div>
    <v-card-text :class="statusClass" v-if="shooting.remarketingShootingStatus">{{ statusText }}</v-card-text>
    <div>
      <v-card-subtitle class="pa-0 mt-1 truncate">
        <div class="text-subtitle-1">{{ shooting.registration }}</div>
        <v-card-text class="pa-0">{{ formatDate }}</v-card-text>
      </v-card-subtitle>
    </div>
    <v-row class="text-left spacing-0 pb-1" no-gutters dense>
      <v-col cols="12">
        <ShootingItemContent
          v-if="shooting.stamps?.length"
          :title="$t('shootings.appliedStamp')"
          :content="shooting.stamps[0].name"
        />
      </v-col>
      <v-col cols="12" v-if="shooting.productModel">
        <ShootingItemContent :title="$t('shooting.details.model')" :content="shooting.productModel" />
      </v-col>
      <v-col cols="12">
        <ShootingItemContent :title="$t('shooting.details.stock')" :content="shooting.ownerName" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import BannerIconShootingType from '@/components/common/organims/BannerIconShootingType'
import { getCssClass, getStatusText } from '@/helpers/statusStyles'
import moment from 'moment'
import ShootingItemContent from './ShootingItemContent'

export default {
  name: 'ShootingsItem',

  components: {
    BannerIconShootingType,
    ShootingItemContent
  },

  props: {
    shooting: {
      type: Object,
      required: true
    }
  },

  computed: {
    formatDate() {
      return moment(this.shooting.created).format('DD/MM/YYYY')
    },
    goToShooting() {
      let path
      if (this.shooting.shootingType === 'STANDARD') {
        path = `/owners/${this.shooting.ownerId}/products/${this.shooting.productId}/shootings/${this.shooting.shootingId}`
      } else if (this.shooting.shootingType === 'INSPECTION') {
        path = `/owners/${this.shooting.ownerId}/products/${this.shooting.productId}/shootings/${this.shooting.shootingId}/inspect`
      } else if (this.shooting.shootingType === 'VIDEO') {
        path = `/owners/${this.shooting.ownerId}/products/${this.shooting.productId}/shootings/${this.shooting.shootingId}/video`
      } else if (this.shooting.shootingType === 'INSPECTION_REPAIR_ORDER') {
        path = `/owners/${this.shooting.ownerId}/products/${this.shooting.productId}/shootings/${this.shooting.shootingId}/inspection-repair-order`
      }
      return { path }
    },
    statusClass() {
      return getCssClass(this.shooting.remarketingShootingStatus) + ' py-0 px-3 rounded-t-0'
    },
    statusText() {
      return getStatusText(this.shooting.remarketingShootingStatus)
    }
  }
}
</script>

<style lang="less" scoped>
.img-thumbnail-block {
  overflow: hidden;
  height: 150px;
}

.video-thumbnail {
  cursor: pointer;
  transition: 0.2s transform ease-in-out;
  background-color: #ebebeb;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-thumbnail {
  cursor: pointer;
  transition: 0.2s transform ease-in-out;
  background-color: #ebebeb;
}

.image-description {
  text-align: center;
}

.image-block:hover .img-thumbnail {
  transform: scale(1.1);
}

.center-card {
  text-align: center;
}

.custom-height {
  height: 38px;
  padding-bottom: 16px;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
